import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("patient@demo.com");
  const [password, setPassword] = useState("Patient@123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      const roleMap = {
        admin: "/admin",
        doctor: "/doctor",
        hospital_admin: "/hospital",
        lab_admin: "/lab",
      };
      nav(roleMap[user.role] || "/app");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Unable to sign in");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-bone">
      <div className="hidden md:flex relative bg-ayurveda text-bone p-12 flex-col justify-between grain">
        <Link to="/" className="font-heritage text-3xl">Gutvibe</Link>
        <div>
          <div className="overline text-terracotta mb-4">Sign in</div>
          <h1 className="font-heritage text-5xl leading-tight">Welcome back.<br/>Your health, gently guided.</h1>
          <p className="mt-6 text-bone/70 max-w-md">Your consent-first companion — Priya, our Malayali AI — for verified doctors, labs, nutrition and emergency support across India.</p>
        </div>
        <div className="text-xs text-bone/50">Consent · Voice · Human oversight</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <div className="overline text-terracotta mb-2">Sign in</div>
            <h2 className="font-heritage text-4xl text-ayurveda">Namaste</h2>
            <p className="text-sm text-charcoal/60 mt-2">Enter your email to continue.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-ayurveda hover:bg-ayurveda/90 text-bone h-11" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <div className="text-sm text-charcoal/70">
            New to Gutvibe Health? <Link to="/register" className="text-ayurveda font-medium underline underline-offset-4" data-testid="link-register">Create an account</Link>
          </div>
          <div className="text-sm text-charcoal/70 text-center border-t pt-4">
            <Link to="/login/otp" className="text-ayurveda font-medium underline underline-offset-4" data-testid="link-otp-login">Sign in with phone (OTP) →</Link>
          </div>
          <div className="text-xs text-charcoal/50 border-t pt-4">
            <div><strong>Demo:</strong> patient@demo.com · Patient@123</div>
            <div><strong>Admin:</strong> admin@aarogya.ai · Admin@12345</div>
          </div>
        </form>
      </div>
    </div>
  );
}
